import { Link, useNavigate } from "react-router-dom";
import { BookHeart, LogOut, Smile } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Logo = () => (
  <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
    <BookHeart className="h-5 w-5 text-[#3B5BDB]" strokeWidth={1.6} />
    <span className="font-serif text-xl tracking-tight sm:text-2xl">Click, Print <span className="text-[#3B5BDB]">&amp;</span> Doodle</span>
  </Link>
);

export default function Nav({ right }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 border-b border-[#E8E2D9]/70 bg-[#FDFBF7]/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="flex items-center gap-2 sm:gap-3">
          {right}
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard-link" className="hidden sm:inline text-sm text-[#5E5868] hover:text-[#26232E] px-2">
                My books
              </Link>
              <Link to="/pricing" data-testid="nav-pricing-link" className="hidden md:inline whitespace-nowrap px-2 text-sm text-[#5E5868] hover:text-[#26232E]">Pricing</Link>
              {user.role === "admin" && <Link to="/admin/orders" data-testid="nav-admin-orders-link" className="whitespace-nowrap px-2 text-sm font-medium text-[#3B5BDB]">Orders</Link>}
              {user.role === "admin" && <Link to="/admin/promos" data-testid="nav-admin-promos-link" className="hidden md:inline whitespace-nowrap px-2 text-sm font-medium text-[#3B5BDB]">Promos</Link>}
              <Link to="/caricature" data-testid="nav-caricature-link" className="btn-ghost !py-2 !px-3 sm:!px-4" aria-label="Make a Caricature"><Smile className="h-4 w-4" /><span className="hidden sm:inline">Make a Caricature</span></Link>
              <Link to="/new" data-testid="nav-create-book-btn" className="btn-primary whitespace-nowrap !py-2 !px-4">New book</Link>
              <button
                data-testid="nav-logout-btn"
                onClick={async () => { await logout(); nav("/"); }}
                className="p-2 text-[#8C8498] hover:text-[#26232E]"
                aria-label="Log out"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </>
          ) : user === false ? (
            <>
              <Link to="/pricing" data-testid="nav-pricing-link" className="hidden sm:inline whitespace-nowrap px-2 text-sm text-[#5E5868] hover:text-[#26232E]">Pricing</Link>
              <Link to="/login" data-testid="nav-login-link" className="whitespace-nowrap px-2 text-sm text-[#5E5868] hover:text-[#26232E]">Log in</Link>
              <Link to="/caricature" data-testid="nav-caricature-link" className="btn-ghost !py-2 !px-3 sm:!px-4" aria-label="Make a Caricature"><Smile className="h-4 w-4" /><span className="hidden sm:inline">Make a Caricature</span></Link>
              <Link to="/register" data-testid="nav-signup-btn" className="btn-primary whitespace-nowrap !py-2 !px-3 sm:!px-4">Start a book</Link>
            </>
          ) : null}
        </nav>
      </div>
    </header>
  );
}
